import React from "react";
import Core from "../components/Core";
import Template2013Component from "./Template2013Component";

import screenProvider from "./Template2013ScreenProvider";
import dataProvider from "./Template2013DataProvider";
import { baseEventHandler } from "../services";

export default class Template2013Container extends React.Component {
    render() {
        return (
            <Core
                screenProvider={screenProvider}
                eventHandler={baseEventHandler}
                dataProvider={dataProvider}
                scrollLimit={2}
                {...this.props}
            >
                {(props) => <Template2013Component {...props} />}
            </Core>
        );
    }
}
